import React from 'react';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { nanoid as generate } from 'nanoid';

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    padding: 4,
    backgroundColor: '#F3F4F6',
    borderBottom: '1px solid #DFE2E7'
  },
  text: {
    fontFamily: 'Noto Sans',
    fontSize: 10
  }
});

export interface TableHeaderItem {
  label: string;
  labelRateTank?: string;
  labelRateArea?: string;
  styles?: Record<string, any>;
}

interface TableHeaderProps {
  items: TableHeaderItem[];
}

const TableHeader: React.FC<TableHeaderProps> = ({ items = [] }) => (
  <View style={styles.container}>
    {items.map(item => (
      <Text
        style={[
          styles.text,
          {
            ...item.styles,
            width: item.styles?.width
              ? item.styles?.width
              : `${100 / items.length}%`
          }
        ]}
        key={`header-${generate()}`}
      >
        {item.label}
      </Text>
    ))}
  </View>
);

export default TableHeader;
